module.exports = __webpack_public_path__ + "static/img/yuyueguahao.e7e09f94.png";